import CreateESuranceMembershipRequestModelBase from '../_generated/modelBases/create-e-surance-membership-request-model-base';

export default class CreateESuranceMembershipRequestModel extends CreateESuranceMembershipRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
